import { render, staticRenderFns } from "./curveStyle.vue?vue&type=template&id=436d4f20&"
import script from "./curveStyle.vue?vue&type=script&lang=ts&"
export * from "./curveStyle.vue?vue&type=script&lang=ts&"
import style0 from "./curveStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports